<template>
  <v-dialog
    v-model="isActive"
    @click:outside="closeDialog()"
    max-width="500"
    scrollable
  >
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Buscar Registro
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-row dense justify="center">
              <!-- Nombre -->
              <v-col cols="12" v-if="['queueList', 'agentList'].includes(type)">
                <v-text-field
                  v-model="payload.name"
                  class="rounded-small"
                  label="Nombre"
                  prepend-inner-icon="mdi-text-short"
                  required
                  filled
                  rounded
                  dense
                  clearable
                >
                </v-text-field>
              </v-col>
              <!-- Email -->
              <v-col cols="12" v-if="['agentList'].includes(type)">
                <ValidationProvider
                  name="Email"
                  rules="email"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.email"
                    :error-messages="errors"
                    label="Email"
                    prepend-inner-icon="mdi-email"
                    class="rounded-small"
                    required
                    filled
                    rounded
                    dense
                    clearable
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Extension -->
              <v-col cols="12" v-if="['agentList'].includes(type)">
                <v-text-field
                  v-model="payload.extension"
                  label="Extension"
                  prepend-inner-icon="mdi-call-merge"
                  class="rounded-small"
                  required
                  filled
                  rounded
                  dense
                  clearable
                >
                </v-text-field>
              </v-col>
              <!-- Fecha -->
              <v-col cols="12" v-if="['typificationList'].includes(type)">
                <v-menu
                  ref="dateMenu"
                  v-model="isDateMenuOpen"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  close-on-click
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="payload.date"
                      v-on="on"
                      prepend-inner-icon="mdi-calendar"
                      class="rounded-small"
                      label="Fecha"
                      required
                      filled
                      rounded
                      readonly
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-us"
                    v-model="payload.date"
                    scrollable
                    no-title
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- Rango de Fecha -->
              <v-col
                cols="12"
                v-if="['agentList', 'typificationList'].includes(type)"
              >
                <v-menu
                  ref="dateMenu"
                  v-model="isDateRangeMenuOpen"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="
                        rangeDate.length > 0
                          ? `${rangeDate[0] || ''} - ${rangeDate[1] || ''}`
                          : ''
                      "
                      @click:clear="rangeDate = []"
                      v-on="on"
                      prepend-inner-icon="mdi-calendar"
                      class="rounded-small"
                      label="Rango de Fecha"
                      required
                      filled
                      rounded
                      clearable
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-us"
                    v-model="rangeDate"
                    scrollable
                    no-title
                    range
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- Campaña -->
              <v-col cols="12">
                <v-select
                  v-model="campaignToFilter"
                  prepend-inner-icon="mdi-bell"
                  required
                  filled
                  rounded
                  dense
                  class="rounded-small"
                  item-text="name"
                  item-value="id"
                  :items="campaignList"
                  label="Campaña"
                ></v-select>
              </v-col>

              <!-- Numero -->
              <v-col cols="12" v-if="['typificationList'].includes(type)">
                <ValidationProvider
                  name="Numero"
                  rules="numeric"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.number"
                    :error-messages="errors"
                    class="rounded-small"
                    label="Numero"
                    prepend-inner-icon="mdi-numeric"
                    required
                    filled
                    rounded
                    dense
                    clearable
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Buscar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    idQueue: {
      type: Number,
    },
  },

  data() {
    return {
      isDateMenuOpen: false,
      isDateRangeMenuOpen: false,
      payload: {},
      rangeDate: [],
      campaignList: [],
      campaignToFilter: null,
    };
  },

  created() {
    this.getCampaigns();
  },

  methods: {
    async getCampaigns() {
      try {
        const { data } = await PbxHttpClient.get(
          `/campaign/campaign_select/${this.idQueue}`
        );
        this.campaignList = data;
      } catch (err) {
        console.log("error getting campaign", err);
      }
    },

    closeDialog(params = {}) {
      this.$emit("dialog:close", params);
    },

    submitForm() {
      this.payload.campaign_id = this.campaignToFilter;
      const params = {
        ...this.getRangeDates(),
        ...this.getNonEmptyAttributes(this.payload),
      };
      this.closeDialog(params);
    },
    getRangeDates() {
      return this.rangeDate.length > 0
        ? {
            dateStart: this.rangeDate[0],
            dateEnd: this.rangeDate[1] || undefined,
          }
        : {};
    },

    getNonEmptyAttributes(obj) {
      return Object.keys(obj)
        .filter((k) => ![null, ""].includes(obj[k]))
        .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
    },
  },
};
</script>

<style></style>
